import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'
import useSelectedUserId from './useSelectedUserId'

const query = gql`
  query userUnavailabilities($userId: ID!) {
    user(id: $userId) {
      id
      unavailabilities {
        from
        to
      }
    }
  }
`

/**
 * Provide the unavailabilities of the selected user
 */
export default function useSelectedUserUnavailabilities() {
  // retrieve the currently selected user id
  const [userId] = useSelectedUserId()

  // retrieve user unavailabilities
  const { loading, data: { user: { unavailabilities = [] } = {} } = {} } = useQuery(query, { variables: { userId } })

  return {
    unavailabilities,
    loading,
  }
}
